import { useWallet } from '@trinity/wallet-react'
import type { FC, ReactNode } from 'react'

interface Props {
    children: ReactNode
    noWalletElement?: ReactNode
}

export const WalletGuard: FC<Props> = ({ children, noWalletElement = null }) => {
    const { address, isReady } = useWallet()
    if (!isReady) {
        return null
    }

    if (!address) {
        return noWalletElement
    }

    return children
}
